import React from "react";

export type SensitiveDataProps = {
  children: React.ReactNode;
};

// This component adds an `fs-hide` class to all `children`
// which will hide them from FullStory. Use it to wrap senstive
// data like credit card fields, etc.
// Note that the children _must_ accept and apply a `className` prop
// for this to work properly!
function SensitiveData({ children }: SensitiveDataProps) {
  return (
    <React.Fragment>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(child, {
          className: `fs-hide ${child.props.className || ""}`.trim(),
        });
      })}
    </React.Fragment>
  );
}

export default SensitiveData;
